<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <div class="level-box">
    <div class="level-title">
      <span>您的词汇水平相当于: <em>{{ masteryName }}</em></span>
    </div>

    <div class="level-bars">
      <div
        v-for="(item, index) in levelMasteryRates"
        :key="'bar-' + index + '-' + (item.levelName || item.percent)"
        class="bar-shell"
      >
        <div
          class="bar"
          :class="'bar' + ((index % 3) + 1)"
          :style="{ '--bar-width': barPercent(item) + '%' }"
        >
          <span v-if="hasLevelBarCopy(item)" class="bar-text"
            >{{ item.levelName }}{{ item.masterName }} (<CountUp
              :to="barPercent(item)"
              :duration="1200"
              suffix="%"
            />)</span
          >
          <span v-else class="bar-text"
            >{{ getLabelPrefix(item) }}<CountUp
              :to="barPercent(item)"
              :duration="1200"
              suffix="%"
            /></span
          >
        </div>
      </div>
    </div>

    <div class="desc">级别说明:{{ masterDesc }}</div>
  </div>
</template>

<script setup>
import { defineProps } from "vue";
import CountUp from "./CountUp.vue";

defineProps({
  masteryName: { type: String, default: "" },
  masterDesc: { type: String, default: "" },
  levelMasteryRates: { type: Array, default: () => [] },
});

const barPercent = (item) => item.masteryRate ?? item.percent ?? 0;

const hasLevelBarCopy = (item) =>
  (item.levelName != null && String(item.levelName).trim() !== "") ||
  (item.masterName != null && String(item.masterName).trim() !== "");

const getLabelPrefix = (item) => {
  if (item.labelPrefix) return item.labelPrefix;
  if (item.label) return item.label.replace(/\d+%?\)?$/, "");
  return "";
};

</script>

<style scoped lang="scss">
.level-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;

  .level-title {
    font-size: 15px;
    color: #333333;
    font-weight: 500;
    width: 100%;

    em {
      color: #a07dff;
      font-style: normal;
    }
  }

  .level-bars {
    display: flex;
    flex-direction: column;
    gap: 15px;
    width: 100%;
    margin-top: 15px;

    .bar-shell {
      width: 100%;
      height: 22px;
      background: #f4f4f4;
      border-radius: 15px;
      overflow: hidden;
    }

    .bar {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: 100%;
      min-width: fit-content;
      padding: 0 10px;
      border-radius: 15px;
      width: 0;
      animation: barExpand 1s ease-out forwards;
      transition: width 0.8s ease-out;

      @keyframes barExpand {
        to {
          width: var(--bar-width, 100%);
        }
      }

      .bar-text {
        font-size: 12px;
        color: #ffffff;
        white-space: nowrap;
        text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
      }

      &.bar1 {
        background: linear-gradient(90deg, #64beff 0%, #46b1fe 100%);
        box-shadow: inset 0px 0 8px 1px rgba(255, 255, 255, 0.4);
      }

      &.bar2 {
        background: linear-gradient(90deg, #ffae79 0%, #ffa061 100%);
        box-shadow: inset 0px 0 8px 1px rgba(255, 255, 255, 0.4);
      }

      &.bar3 {
        background: linear-gradient(90deg, #ff7878 0%, #ff6f6f 100%);
        box-shadow: inset 0px 0 8px 1px rgba(255, 255, 255, 0.4);
      }
    }
  }

  .desc {
    margin-top: 15px;
    font-size: 14px;
    color: #333333;
    width: 100%;
  }
}
</style>
